import { Button, FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useScreenshot } from './lib/ctx'

export const ScreenshotError = () => {
  const { colors } = useTheme()
  const refresh = useScreenshot((s) => s.refresh)

  return (
    <FlexBox
      className={css`
        padding: 0 24px;
      `}
    >
      <FlexBox
        className={css`
          padding: 32px 24px;
          width: 100%;
          background-color: ${colors.uiWhite70};
          border-radius: 14px;
          gap: 4px;
        `}
        flexDirection="column"
        centerAll
      >
        <Text type="header" sizing="S" align="center" tag="h4">
          Oops!
        </Text>
        <Text
          className={css`
            width: 100%;
            max-width: 240px;
          `}
          type="body"
          sizing="M"
          align="center"
          weight="500"
        >
          We're having trouble generating your image.
        </Text>
        <Button
          className={css`
            margin-top: 16px;
            width: 120px;
          `}
          onClick={() => refresh({ retry: 3 })}
          small
        >
          Try again
        </Button>
      </FlexBox>
    </FlexBox>
  )
}
